import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHeader, TableRow } from '../table';
import type { AdminCity } from '../../stores/adminStore';

interface CityTableProps {
  cities: AdminCity[];
}

const CityTable: React.FC<CityTableProps> = ({ cities }) => {
  const { t } = useTranslation(['admin', 'common']);

  const formatCoord = (value: number | null | undefined): string => {
    if (value === null || value === undefined) return '-';
    return String(value);
  };

  return (
    <div className="max-w-full overflow-x-auto">
      <Table className="w-full">
        <TableHeader className="bg-gray-50 dark:bg-white/[0.05]">
          <TableRow>
            {(['name', 'code', 'latitude', 'longitude', 'created_at'] as const).map(field => (
              <TableCell
                key={field}
                isHeader
                className="text-start px-6 py-4 font-semibold uppercase text-gray-600 text-[0.75rem] tracking-wide dark:text-gray-400"
              >
                {t(`table_fields.${field}`, { ns: 'admin' })}
              </TableCell>
            ))}
          </TableRow>
        </TableHeader>

        <TableBody className="divide-y divide-gray-100 dark:divide-white/[0.05]">
          {cities.map(city => (
            <TableRow
              key={city.id}
              className="transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-white/[0.08]"
            >
              <TableCell className="px-6 py-4">{city.name}</TableCell>
              <TableCell className="px-6 py-4 text-gray-600 dark:text-gray-400 text-sm">
                {city.code}
              </TableCell>
              <TableCell className="px-6 py-4 text-gray-600 dark:text-gray-400 text-sm">
                {formatCoord(city.latitude)}
              </TableCell>
              <TableCell className="px-6 py-4 text-gray-600 dark:text-gray-400 text-sm">
                {formatCoord(city.longitude)}
              </TableCell>
              <TableCell className="px-6 py-4 text-gray-600 dark:text-gray-400 text-sm">
                {city.created_at ? new Date(city.created_at).toLocaleDateString() : '-'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default CityTable;
